<template>
    <div class="flex-1 flex flex-col">
        <article>
            <router-view
                v-slot="{ Component }"
                name="modal"
                :key="$route.params.time"
            >
                <component :is="Component"></component>
            </router-view>

            <main class="flex-1 overflow-y-auto focus:outline-none">
                <div class="relative max-w-4xl mx-auto md:px-8 xl:px-0">
                    <div class="pt-10 pb-16">
                        <div class="rounded-lg bg-white overflow-hidden shadow">
                            <h2 class="sr-only" id="profile-overview-title">
                                {{ t("attendees.title", "Deelnemers") }}
                            </h2>

                            <div class="bg-white p-6">
                                <div
                                    class="sm:flex sm:items-center sm:justify-between"
                                >
                                    <div class="sm:flex sm:space-x-5">
                                        <div
                                            class="flex-shrink-0"
                                            v-if="user.imageUrl"
                                        >
                                            <img
                                                class="mx-auto h-20 w-auto not-rounded-full"
                                                :src="user.imageUrl"
                                                alt=""
                                            />
                                        </div>
                                        <div
                                            class="mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left"
                                        >
                                            <p
                                                class="text-sm font-medium text-blue-600"
                                            >
                                                {{
                                                    t(
                                                        "attendees.overview-title",
                                                        "Overzicht",
                                                    )
                                                }}
                                            </p>
                                            <p
                                                class="text-xl font-bold text-blue-900 sm:text-2xl"
                                            >
                                                {{ user.name }}
                                            </p>
                                            <p
                                                class="text-sm font-medium text-blue-800"
                                            >
                                                {{ user.role }}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        class="mt-5 flex justify-center sm:mt-0"
                                    >
                                        <a
                                            v-if="isLoading"
                                            class="flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled"
                                            :class="{
                                                'bg-red-500 text-white':
                                                    isLoading == 'error',
                                            }"
                                        >
                                            <svg
                                                class="animate-spin h-5 w-5"
                                                :class="{
                                                    'text-white':
                                                        isLoading == 'error',
                                                }"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    class="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    stroke-width="4"
                                                ></circle>
                                                <path
                                                    class="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                ></path>
                                            </svg>
                                        </a>

                                        <router-link
                                            v-if="!isLoading"
                                            :to="{
                                                name: 'attendees-create',
                                                params: {
                                                    time: new Date().getTime(),
                                                },
                                            }"
                                            class="flex justify-center items-center px-4 py-2 shadow-sm text-sm font-medium rounded-md text-blue-50 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                            replace
                                        >
                                            {{
                                                t("attendees.add", "Toevoegen")
                                            }}
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="border-t border-gray-200 bg-gray-50 grid grid-cols-1 divide-y divide-gray-200 sm:grid-cols-3 sm:divide-y-0 sm:divide-x"
                            >
                                <div
                                    v-for="stat in stats"
                                    :key="stat.label"
                                    class="px-6 py-5 text-sm font-medium text-center"
                                >
                                    <span class="text-gray-900"
                                        >{{ stat.label }}:</span
                                    >
                                    {{ " " }}
                                    <span class="text-gray-600">{{
                                        getStat(stat.stat)
                                    }}</span>
                                </div>
                            </div>
                        </div>

                        <article
                            class="bg-white overflow-hidden shadow rounded-lg mt-8 divide-y divide-gray-200"
                        >
                            <section class="px-4 py-5 sm:px-6">
                                <div
                                    class="relative pb-5 border-b border-gray-200 sm:pb-0"
                                >
                                    <div
                                        class="md:flex md:items-center md:justify-between"
                                    >
                                        <h3
                                            class="text-2xl leading-6 font-medium text-blue-900"
                                        >
                                            {{
                                                t(
                                                    "attendees.attendees",
                                                    "Deelnemers",
                                                )
                                            }}
                                        </h3>
                                        <div
                                            class="mt-3 flex md:mt-0 md:absolute md:top-3 md:right-0"
                                        >
                                            <button
                                                type="button"
                                                class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-blue-50 bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 hidden"
                                            >
                                                {{
                                                    t(
                                                        "attendees.import-excel",
                                                        "Import Excel",
                                                    )
                                                }}
                                            </button>
                                            <router-link
                                                :to="{
                                                    name: 'attendees-upload',
                                                }"
                                                v-show="
                                                    $route.name !=
                                                        'attendees-upload' &&
                                                    showUpload == true
                                                "
                                                class="ml-3 inline-flex items-center px-4 py-2 border border-green-700 rounded-md shadow-sm text-sm font-medium text-green-50 bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                                            >
                                                {{
                                                    t(
                                                        "attendees.import-excel",
                                                        "Import Excel",
                                                    )
                                                }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <div class="block">
                                            <nav class="-mb-px flex space-x-8">
                                                <router-link
                                                    v-for="(tab, _key) in tabs"
                                                    :key="tab.name"
                                                    :href="tab.href"
                                                    :to="{ name: tab.href }"
                                                    :class="[
                                                        checkCurrent(
                                                            tab.href,
                                                            _key,
                                                        )
                                                            ? 'border-blue-500 text-blue-600'
                                                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                                                        'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm',
                                                    ]"
                                                    :aria-current="
                                                        tab.current
                                                            ? 'page'
                                                            : undefined
                                                    "
                                                >
                                                    {{ tab.name }}
                                                </router-link>

                                                <SearchIcon
                                                    class="h-5 w-5 text-gray-400 hover:text-blue-700 cursor-pointer -ml-2 mt-1"
                                                    @click="openSearch()"
                                                    aria-hidden="true"
                                                />
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                                <router-view
                                    v-if="!isLoading"
                                    v-slot="{ Component }"
                                    name="tab"
                                    class="pt-4"
                                >
                                    <transition name="fade" mode="out-in">
                                        <component
                                            :users="users"
                                            :is="Component"
                                        ></component>
                                    </transition>
                                </router-view>
                            </section>
                        </article>
                    </div>
                </div>
            </main>
        </article>
    </div>
</template>

<script>
import { SearchIcon } from "@heroicons/vue/solid";

import Attendees from "../../components/Attendees.vue";

export default {
    components: { Attendees, SearchIcon },
    mounted() {
        this.getUsers();
        Eventing.listen("fetchUsers", () => this.getUsers());

        Eventing.listen("hide-upload", () => (this.showUpload = false));
        Eventing.listen("show-upload", () => (this.showUpload = true));

        this.tenant = document.head.querySelector(
            'meta[name="tenant"]',
        ).content;

        Echo.private("users." + this.tenant).listen(".new-user", (e) => {
            this.users.push(e.user);
        });

        this.tabs = [
            {
                name: this.t("attendees.tab.attendees", "Deelnemers"),
                href: "attendees-index",
                current: true,
            },
            {
                name: this.t(
                    "attendees.tab.attendees-inactive",
                    "Inactieve deelnemers",
                ),
                href: "attendees-inactive",
                current: false,
            },
            // { name: "Handmatig toevoegen", href: "attendees-create", current: false },
            // { name: "Offer", href: "#", current: false },
            // { name: "Hired", href: "#", current: false },
        ];

        this.user = {
            name: this.t("attendees.tab.attendees", "Deelnemers"),
            role: document.head.querySelector('meta[name="company"]')?.content,
            imageUrl: document.head.querySelector('meta[name="logo"]')?.content,
        };
        this.stats = [
            {
                label: this.t("attendees.stats.attendees", "Deelnemers"),
                stat: "total",
            },
            {
                label: this.t("attendees.stats.voting_weight", "Stemgewicht"),
                stat: "voting_weight",
            },
            {
                label: this.t("attendees.stats.inactive", "Inactief"),
                stat: "inactive",
            },
        ];

        var show_proxy_voting_stats =
            document.head.querySelector('meta[name="show_proxy_voting_stats"]')
                .content == "true"
                ? true
                : false;
        if (show_proxy_voting_stats) {
            this.stats = [
                {
                    label: this.t("attendees.stats.attendees", "Deelnemers"),
                    stat: "total",
                },
                {
                    label: this.t(
                        "attendees.stats.voting_weight",
                        "Stemgewicht",
                    ),
                    stat: "voting_weight",
                },
                {
                    label: this.t(
                        "attendees.stats.proxies_count",
                        "Volmachten",
                    ),
                    stat: "via_proxy",
                },
            ];
        }
    },
    created() {},
    data() {
        return {
            tabs: [],
            user: {},
            stats: [],
            edit: null,
            users: null,
            isLoading: true,
            showUpload: true,
            tenant: null,
        };
    },
    methods: {
        openSearch() {
            Eventing.fire("openSearchbox");
        },
        getUsers() {
            this.isLoading = true;
            axios
                .get("/api/users")
                .then((response) => {
                    this.users = response.data.data;
                    console.warn(this.users);
                    this.isLoading = false;
                })
                .catch((error) => {
                    // alert(error.response.status);
                    this.isLoading = "error";
                });
        },
        checkCurrent(route, _key) {
            try {
                if (_key == 0) {
                    if (
                        this.$route.name.split("-")[1].includes("edit") ||
                        this.$route.name.split("-")[1].includes("create")
                    ) {
                        return true;
                    }
                }
                return this.$route.name
                    .split("-")[1]
                    .includes(route.split("-")[1])
                    ? true
                    : false;
            } catch (error) {
                this.$router.push({ name: "attendees-index" });
            }
        },
        createOrUpdate() {
            if (this.edit) {
                return true;
            }
            try {
                return this.$route.name.split("-")[1].includes("create")
                    ? true
                    : false;
            } catch (error) {}
        },
        getStat(statistic) {
            var self = this;
            var _count = "…";
            try {
                if (this.users) {
                    switch (statistic) {
                        case "total":
                            var current = this.users.filter(function (u) {
                                return !u.is_blocked;
                            });
                            _count = current.length;
                            break;
                        case "voting_weight":
                            var current = this.users.filter(function (u) {
                                return !u.is_blocked;
                            });
                            let permittedValues = current.map(function (user) {
                                return user.voting_weight + user.proxy_weight;
                            });
                            _count = permittedValues.reduce((a, b) => a + b, 0);
                            break;
                        case "inactive":
                            var current = this.users.filter(function (u) {
                                return u.is_blocked;
                            });
                            _count = current.length;

                            break;
                        case "via_proxy":
                            var current = this.users.filter(function (u) {
                                return u.via_proxy > 0;
                            });
                            _count = current.length;
                            break;
                        default:
                            _count = 0;
                            break;
                    }
                }
                _count = new Intl.NumberFormat("nl-NL", {})
                    .format(_count)
                    .replace("NaN", "…");
            } catch (error) {}
            return _count;
        },
    },
    computed: {},
};
</script>
